(() => {
  document.querySelectorAll('.hw-feedback form').forEach(form => {
    form.addEventListener('submit', () => {
      const selected = form.querySelector('input[name="comment[body]"]:checked');
      const message = form.querySelector('[data-rating-message]');
      if (selected && message) {
        const base = selected.dataset.ratingBase || selected.value;
        selected.dataset.ratingBase = base;
        selected.value = base + '\n' + message.value.trim();
      }
    });
  });
})();
(() => {
  const feedback = document.querySelector('[data-native-feedback-scope]');
  const summaries = [...document.querySelectorAll('[data-native-rating-scope]')];
  const sources = [feedback, ...summaries].filter(Boolean);
  const source = sources.find(el => Number(el.dataset.nativeRatingCount) > 50);
  if (!source) return;
  const url = new URL(source.dataset.nativeRatingSource, location.origin);
  if (url.origin !== location.origin) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);
  const fetchAll = async () => {
    const entries = [];
    let page = 1;
    let pages = 1;
    do {
      url.searchParams.set('page', String(page));
      const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('Ratings unavailable');
      const data = await response.json();
      if (data.page !== page || !Number.isInteger(data.pages) || !Array.isArray(data.comments)) throw new Error('Invalid ratings');
      entries.push(...data.comments);
      pages = data.pages;
      page++;
    } while (page <= pages);
    return entries.flatMap(entry => {
      if (typeof entry.body !== 'string' || typeof entry.author !== 'string') return [];
      const match = entry.body.match(/^\[BG-RATING\|((?:product|article)-\d+)\|([1-5])\]/);
      return match ? [{scope:match[1],score:Number(match[2]),author:entry.author,body:entry.body.slice(match[0].length).trim(),date:entry.date}] : [];
    });
  };
  fetchAll().then(entries => {
    const calculate = scope => {
      const reviews = entries.filter(entry => entry.scope === scope);
      return {reviews,count:reviews.length,average:reviews.length ? Math.round(reviews.reduce((sum,r)=>sum+r.score,0)/reviews.length*100)/100 : 0};
    };
    summaries.forEach(el => {
      const stats = calculate(el.dataset.nativeRatingScope);
      if (stats.count) el.textContent = '★ ' + stats.average + '/5 · ' + stats.count;
    });
    if (!feedback) return;
    const stats = calculate(feedback.dataset.nativeFeedbackScope);
    const summary = feedback.querySelector('.hw-rating-public');
    if (summary) { summary.hidden = !stats.count; summary.textContent = '★ ' + stats.average + '/5 · ' + stats.count; }
    const list = feedback.querySelector('.hw-published-reviews');
    if (list) {
      list.replaceChildren();
      stats.reviews.forEach(review => {
        const row = document.createElement('article'); row.className = 'hw-published-review';
        const author = document.createElement('strong'); author.textContent = review.author;
        const stars = document.createElement('span'); stars.textContent = '★'.repeat(review.score) + '☆'.repeat(5-review.score);
        stars.setAttribute('aria-label',review.score + '/5');
        const text = document.createElement('p'); text.textContent = review.body;
        const date = document.createElement('small'); date.textContent = review.date;
        row.append(author,stars,text,date); list.append(row);
      });
    }
    if (stats.count && feedback.dataset.nativeFeedbackScope.startsWith('product-')) {
      const schema = document.createElement('script'); schema.type = 'application/ld+json';
      schema.dataset.nativeRatingsSchema = '';
      schema.textContent = JSON.stringify({'@context':'https://schema.org','@type':'Product','@id':feedback.dataset.nativeRatingUrl+'#product',name:feedback.dataset.nativeRatingName,aggregateRating:{'@type':'AggregateRating',ratingValue:stats.average,ratingCount:stats.count,bestRating:5,worstRating:1}});
      document.head.append(schema);
    }
  }).catch(() => {
    feedback?.querySelector('.hw-rating-public')?.setAttribute('hidden','');
  }).finally(() => clearTimeout(timeout));
})();